import { createNamespacedDataProviderStore, extendStore } from './dataprovider';
import ApiClient from '../../client';

const store = createNamespacedDataProviderStore((setItems) => {
  return ApiClient.getMatches()
    .then((response) => {
      setItems(response.data || []);
    })
    .catch(() => {
      setItems([]);
    });
});

export default extendStore(store, {
  getters: {
    getMatches: (state) => state.items,
    getMatchById: (state) => (id) => state.items.find((m) => m.matchId === id),
    matchCount: (state) => state.items.length
  }
});
